<div class="loading_overlay rounded" *ngIf="showSpinner">
    <app-loader></app-loader>
</div>
<div class="container-fluid">
    <div class="row">
        <div *ngIf="mylist" class="col">
            <ng-container *ngIf="taskList.length == 0">
                <a class="link-toggle cursor-default" role="button">
                    <h6 *ngIf="mylist" class="d-inline link-text cursor-default">{{ 'customertasklist.mytasks' | trans }}</h6></a>
            </ng-container>
            <ng-container *ngIf="taskList.length > 0">
                <a data-toggle="collapse" class="link-toggle cursor-pointer" href="#tasklistcollapse1" role="button">
                    <h6 *ngIf="mylist" class="d-inline link-text cursor-pointer">{{ 'customertasklist.mytasks' | trans }}</h6>
                    <span class="d-inline material-icons link-icon align-middle cursor-pointer">
                    expand_more
                    </span>
                </a>
            </ng-container>
        </div>
        <div *ngIf="!mylist" class="col">
            <ng-container *ngIf="taskList.length == 0" >
                <a  class="link-toggle cursor-default" role="button">
                    <h6 *ngIf="!mylist" class="d-inline link-text cursor-default">{{ 'customertasklist.alltasks' | trans }}</h6></a>
            </ng-container>
            <ng-container *ngIf="taskList.length > 0" >
                <a data-toggle="collapse" class="link-toggle cursor-pointer" href="#tasklistcollapse2" role="button">
                    <h6 *ngIf="!mylist" class="d-inline link-text cursor-pointer">{{ 'customertasklist.alltasks' | trans }}</h6>
                    <span class="d-inline material-icons link-icon align-middle cursor-pointer">
                    expand_more
                    </span></a>
            </ng-container>
        </div>
    </div>
      <div *ngIf="mylist" class="collapse show fade" id="tasklistcollapse1">
        <div *ngIf="taskList.length == 0" class="card bg-secondary mt-2">
            <div class="card-body">
                <p class="mb-0">{{ 'customertasklist.noassigned' | trans }}</p>
            </div> 
        </div>
        <app-projecttask *ngFor="let t of taskList | slice:0:4" [customermyview]="true" [userview]="false" [commentsList]="" [projectCustomerMembers]="customerUsers" [projectMembers]="" [task]="t"></app-projecttask>
      </div>
    <div *ngIf="mylist" class="collapse" id="tasklistcollapse1">
        <app-projecttask *ngFor="let t of taskList" [userview]="false" [customermyview]="true" [commentsList]="" [projectCustomerMembers]="customerUsers" [projectMembers]="" [task]="t"></app-projecttask>
    </div>
    <div *ngIf="!mylist" class="collapse show fade" id="tasklistcollapse2">
        <div *ngIf="taskList.length == 0" class="card bg-secondary mt-2">
            <div class="card-body">
                <p class="mb-0">{{ 'customertasklist.noassigned' | trans }}</p>
            </div> 
        </div>
        <app-projecttask *ngFor="let t of taskList | slice:0:4" [customermyview]="false" [customerourview]="true" [userview]="false" [commentsList]="" [projectCustomerMembers]="customerUsers" [projectMembers]="" [task]="t"></app-projecttask>
      </div>
    <div *ngIf="!mylist" class="collapse" id="tasklistcollapse2">
        <app-projecttask *ngFor="let t of taskList" [userview]="false" [customermyview]="false" [customerourview]="true" [commentsList]="" [projectCustomerMembers]="customerUsers" [projectMembers]="" [task]="t"></app-projecttask>
    </div>
</div>  


